import types from 'redux/types';
import { checkTypeValue } from 'helpers';

const initialState = {
  data: {},
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }
  switch (actions.type) {
    case types.SAVE_USER_INFO:
      return {
        ...state,
        data: actions?.nextUserInfo || {},
      };

    case types.REQUEST_USER:
      return {
        ...state,
        isFetching: actions?.refetch ? false : true,
      };

    case types.REQUEST_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: actions.data,
      };

    case types.REQUEST_USER_FAILED:
      return {
        ...state,
        error: actions.error,
        isFetching: false,
      };

    default:
      return state;
  }
};
